import { Component, OnInit } from '@angular/core';
import { OfbizList } from '@urbannex/ofbiz-forms';
import { SummaryViewCard } from '../shared/model';
import { UbsComponentStoreService } from '../ubs-component-store.service';

@Component({
  selector: 'ubs-view-container',
  templateUrl: './view-container.component.html',
  styleUrls: ['./view-container.component.scss']
})
export class ViewContainerComponent implements OnInit {
  selectedValue:any;
  componentConfig:any;
  views:SummaryViewCard[];
  viewType:string;
  listForm:any;
  result:any;
  state = this.componentStore.vm$;

  constructor(private componentStore:UbsComponentStoreService) { }

  ngOnInit(): void {
    this.componentStore.vm$.subscribe(data => {
      //this.state = data;
      this.selectedValue = data["selectedValue"];
      if(this.selectedValue["event"]){
        switch (this.selectedValue["event"]) {
          case "view":
            console.log("it's a view:",this.selectedValue);
            if(this.selectedValue["type"]){
              this.viewType = this.selectedValue["type"];
            }
            break;
          case "list":
            console.log("It's a list:",this.selectedValue);
            this.viewType = "list";
            let formName = this.selectedValue["type"];
            if(data["componentConfig"].listForm && data["componentConfig"].listForm.listFormName == formName){
              this.listForm = data["componentConfig"].listForm;
              //console.log("it's a top list form");
            }else if(data["componentConfig"].listForm.linkedList && data["componentConfig"].listForm.linkedList.listFormName == formName){
              //console.log("it's a linked list form");
              this.listForm = data["componentConfig"].listForm.linkedList;
              //this.result = data["selectedValue"].data.list;
              //console.log(this.result);
            }
            break;
        
          default:
            break;
        }
      }
      /* if(this.selectedValue["event"] && this.selectedValue["event"] == "view"){
        console.log("It's a view ......");
        if(this.selectedValue["type"]){
          this.viewType = this.selectedValue["type"]
        }
      } */
      this.componentConfig = data["componentConfig"];
      if(this.componentConfig["summaryView"]){
        this.views = this.componentConfig["summaryView"];
      }
      console.log(this.selectedValue)
      console.log(this.componentConfig);
    })
    
  }

}
